import React from 'react';
import { useNavigate } from 'react-router-dom';

const ToolsLanding: React.FC = () => {
  const navigate = useNavigate();

  const tools = [
    {
      id: 'mmt',
      name: 'Money Mindset Tool',
      description: 'Combine how you spend with how you feel to get a full picture on your money mindset.',
      color: 'bg-primary',
      hoverColor: 'hover:bg-primary/90',
    },
    {
      id: 'side-hustle',
      name: 'Side Hustle Builder',
      description: 'Build your side hustle from passion to profit with guided planning and budgeting.',
      color: 'bg-primary',
      hoverColor: 'hover:bg-primary/90',
    },
  ];

  const handleToolClick = (toolId: string) => {
    navigate(`/auth?tool=${toolId}`);
  };

  return (
    <div className="min-h-screen bg-secondary">
      <div className="flex flex-col items-center justify-center p-6 min-h-screen">
        <div className="max-w-5xl w-full">
          <h1 className="text-6xl font-bold text-primary mb-4 text-center">
            MiniMoney Tools
          </h1>

          <p className="text-xl text-gray-700 text-center mb-16 max-w-2xl mx-auto">
            Select a tool to get started on your financial and entrepreneurial journey
          </p>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            {tools.map((tool) => (
              <button
                key={tool.id}
                onClick={() => handleToolClick(tool.id)}
                className={`${tool.color} ${tool.hoverColor} text-white p-8 rounded-3xl shadow-xl transition-all transform hover:scale-105 text-left`}
              >
                <h2 className="text-3xl font-bold mb-4">{tool.name}</h2>
                <p className="text-lg text-white/90">{tool.description}</p>
              </button>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ToolsLanding;
